import React, { useState } from 'react'
import { ChangeAudioSetting, ZoomIn, Rate, RateButton } from './Style'
import { Stack, Slider } from '@mui/material'
import { useSelector } from 'react-redux'
import { useDispatch } from 'react-redux'
import { keyBy } from 'lodash'
import { surferHooks } from '.'

const ChangeSetting = () => {
    const dispatch = useDispatch()

    const { rate } = useSelector(state => state.wavesurfer)

    const rateBtns = surferHooks.useRateBtns()
    const rateBtnKeys = keyBy(rateBtns, "id")

    const [zoom, setZoom] = useState(15)
    const [selectedBtn, setSelectedBtn] = useState(rateBtnKeys[rate].id)

    const { wavesurfer } = useSelector(state => state.wavesurfer)

    const zoomIn = (e, value) => {
        setZoom(value)
        wavesurfer.zoom(value * 10);
    }

    return (
        <ChangeAudioSetting>
            <Rate>
                {rateBtns.map((rateBtn) => {
                    const { label, color, id, icon, action, rightIcon, markSelected } = rateBtn

                    const handleClick = () => {
                        if (markSelected)
                            setSelectedBtn(id)
                        action()
                    }

                    return (
                        <RateButton
                            selected={selectedBtn === id}
                            onClick={handleClick}
                            key={id}
                            className="solid-round"
                            size="small"
                            variant={selectedBtn === id ? null : "solid2"}
                            color={color}
                            $rightIcon={rightIcon}
                        >
                            {label}
                            {icon}
                        </RateButton>
                    )
                })}
            </Rate>
            <ZoomIn>
                <Stack className='zoom-in' direction="row" sx={{ mb: 1 }} alignItems="center">
                    <span className='min-max'>{"Max"}</span>
                    <Slider className='slider' aria-label="Default" value={zoom} onChange={zoomIn} />
                    <span className='min-max'>{"Min"}</span>
                </Stack>
            </ZoomIn>
        </ChangeAudioSetting>
    )
}

export default ChangeSetting